import { useMemo } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { Modal, Select } from "components";
import { Button } from "expano-components";
import useCreate from "hooks/useCreate";
import useGet from "hooks/useGet";

const SelectField = (props) => <Select {...props} />;

const AddChannel = ({
  brand_id,
  existing_channel_ids,
  handleClose,
  handleSubmit,
  pristine,
  invalid,
  refetch,
  change,
}) => {
  const { is_creating, create } = useCreate({
    path: "/brand_channels",
    onSuccess: () => [refetch(), handleClose()],
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["channel", "brand"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const { data: channels } = useGet({
    query: ["channels", existing_channel_ids],
    path: "/channels",
    context: "list",
    search: {
      "q[id_not_in]": existing_channel_ids,
      per_page: 10_000,
    },
  });

  const channel_options = useMemo(() => {
    return channels?.reduce((acc, acu) => {
      const label = acu.platform.type.split("::")[0];
      const group_index = acc.findIndex((item) => item.label === label);
      if (group_index > -1) {
        acc[group_index].options.push({ label: acu.identifier, value: acu.id });
        return acc;
      } else {
        return [
          ...acc,
          { label, options: [{ label: acu.identifier, value: acu.id }] },
        ];
      }
    }, []);
  }, [channels]);

  const onSubmit = ({ channel_id }) =>
    create({
      channel_id,
      brand_id,
    });

  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: "Przypisz kanał",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            text="Dodaj"
            disabled={pristine || invalid || is_creating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <Field
        name="channel_id"
        label="Kanał sprzedażowy"
        component={SelectField}
        options={channel_options}
        handleChange={(value) => change("channel_id", value)}
      />
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.channel_id) {
    errors.channel_id = "Kanał jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "assign_brand_to_producer",
  initialValues: { channel_id: null },
  validate,
})(AddChannel);
